import React, {Component} from "react";
import PropTypes from 'prop-types';
import { FormControl, FormGroup, Glyphicon } from "react-bootstrap";
import './index.css';

class AuthInput extends Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.string)
  };

  static defaultProps = {
    label: '',
    value: null,
    errors: []
  };

  handleInput = (ev) => {
    this.props.onChange(ev.target.value);
  }

  renderErrorList () {
    if (!this.props.errors.length) {
      return null;
    }
    return (
      <div className='auth-error-message has-error'>
        {this.props.errors.map((err, i) => {
          return (
            <p className="control-label inline-error-item"
               key={i}>
              <Glyphicon glyph="exclamation-sign"/>
                {this.props.label} {err}
            </p>
          );
        })}
      </div>
    );
  }

  render () {
    const {errors, groupClassName, ...inputProps} = this.props;
    return (
      <FormGroup className="auth-input">
        <FormControl
          {...inputProps}
          bsStyle={errors.length ? "error" : null}
          onChange={this.handleInput}
        />
        {this.renderErrorList()}
      </FormGroup>
    );
  }
}

export default AuthInput;



// WEBPACK FOOTER //
// ./src/shared/components/auth/Input/index.js